var alignment_rtlignore_default = {
  "alignLeft": "yHI9s",
  "textWrapNowrap": "O-eKz",
  "alignRight": "Jq2sq",
  "alignCenter": "IN-NV",
  "sizeFullWidth": "_6vwpd",
  "renderedInTable": "psnEg",
  "sizeOriginal": "_2c6hZ",
  "sizeContent": "Ky4n7",
  "sizeSmall": "nLqZt",
  "sizeSmallCenter": "GzyVA",
  "flex": "_1-qEz",
  "LEFT": "MXRFf",
  "CENTER": "uGQBe",
  "RIGHT": "_1zP-F",
  "AUTO": "soCUY",
  "JUSTIFY": "nzkje"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
